import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';

export interface ContextMenuItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  dividerAfter?: boolean;
}

export interface ContextMenuProps {
  open: boolean;
  onClose: () => void;
  anchorPosition?: { top: number; left: number };
  anchorEl?: HTMLElement | null;
  items: ContextMenuItem[];
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  open,
  onClose,
  anchorPosition,
  anchorEl,
  items,
}) => (
  <Menu
    open={open}
    onClose={onClose}
    anchorReference={anchorPosition ? 'anchorPosition' : 'anchorEl'}
    anchorPosition={anchorPosition}
    anchorEl={anchorEl}
    data-testid="context-menu"
  >
    {items.map(item => (
      <React.Fragment key={item.key}>
        <MenuItem
          onClick={() => {
            item.onClick();
            onClose();
          }}
          disabled={item.disabled}
          data-testid={`context-menu-item-${item.key}`}
        >
          {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
          <ListItemText>{item.label}</ListItemText>
        </MenuItem>
        {item.dividerAfter && <Divider />}
      </React.Fragment>
    ))}
  </Menu>
);

export default ContextMenu;
